<formstep-detail :options="options" :editable="true" :model="instrument"></formstep-detail>